<template>
    <div>
        <button @click="payDirectMessage" style="margin-top:20px;padding:10px;">부모가 대신 결제하기</button>

        <button @click="getDirectMessageInfoByParent" style="margin-top:20px;padding:10px;">자식 결제 정보 가져오기</button>

    </div>
</template>

<script>
    import ResponseCode from "../../../ResponseCode";

    export default {
        name: "TestParentPay",
        data(){
            return {
                amt: 1000,
                target : 'OC5lMzgyY2NmODI0M2QwOTA='
            }
        },
        methods : {
            payDirectMessage(){
                if (!this.$Util.checkLogin()) return;
                this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '다이렉트 요청서 보내기', amt: this.amt});
            },
            async payAction(pay_method, pay_mode, card_idx) {
                const parameters = {};
                parameters.pay_mode = pay_mode;
                // amt 실제결제금액
                parameters.amt = this.amt;
                parameters.goods_name = '다이렉트 요청서 보내기';
                parameters.card_idx = card_idx;
                // 해당되는 idx
                parameters.target = this.target;

                await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                    return await this.$Axios.post('/api/pay/direct/message/save/by_parent', converted_parameters);
                }, async (converted_parameters) => {
                    const res = await this.$Axios.post('/api/pay/direct/message/save/by_parent', converted_parameters);
                    if (res.data.code === ResponseCode.SUCCESS) {
                        this.$GlobalStore.closeLastModal();
                    } else if (res.data.code === ResponseCode.FAIL) {
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                })
            },
            async getDirectMessageInfoByParent(){
                const parameters = {};
                parameters.target = this.target;

                const res = await this.$Axios.get('/api/pay/direct/message/info/by_parent', {params : parameters});
                res;
            }
        }
    }
</script>

<style scoped>

</style>